// Coordenades oficials revisades – Living Soils
export const centres = [
  {
    id: "parellada",
    name: "Escola La Parellada",
    latitude: 41.252526290822054,
    longitude: 1.555116982037314,
    description: "La Parellada · Santa Oliva (Tarragona)",
  },
  {
    id: "xoriguer",
    name: "Escola Xoriguer",
    latitude: 41.80075272739689,
    longitude:  2.224070468567695,
    description: "Xoriguer · Centelles (Barcelona)",
  },
  {
    id: "espai3",
    name: "Escola Espai 3",
    latitude: 41.36951061954019,
    longitude: 2.0623861550584786,
    description: "Espai 3 · Sant Joan Despí (Barcelona)",
  },
  {
    id: "col-joan-maragall",
    name: "Col·legi Públic Joan Maragall",
    latitude:42.195670030035224,
    longitude: 2.1918244109116714,
    description: "CP Joan Maragall · Ripoll (Girona)",
  },
  {
    id: "cabreres",
    name: "Institut Escola El Cabrerès",
    latitude: 42.031422382181034,
    longitude: 2.368146928836078,
    description: "El Cabrerès · L'Esquirol (Barcelona)",
  },
  {
    id: "consol-ferre",
    name: "Escola Consol Ferré",
    latitude: 40.702580462862876,
    longitude: 0.5832930460511959,
    description: "Consol Ferré · Amposta (Tarragona)",
  },
  {
    id: "sant-domenech",
    name: "Escola Sant Domènec",
    latitude: 41.31284801940768,
    longitude: 1.6476458820397277,
    description: "Sant Domènec · La Ràpita (Barcelona)",
  },
  {
    id: "mas-rampinyo",
    name: "Institut Escola Mas Rampinyo",
    latitude: 41.49853086172954,
    longitude: 2.1785898973915208,
    description: "Mas Rampinyo · Montcada i Reixac (Barcelona)",
  } ,
  {
    id: "daina",
    name: "Escola La Daina",
    latitude:  42.33182373599656,
    longitude: 2.3120724974254876,
    description: "La Daina · Vilallonga de Ter (Girona)",
  },
  {
    id: "joan-maragall",
    name: "Escola Joan Maragall",
    latitude: 41.568150691651255,
    longitude: 1.6416966243778912,
    description: "Joan Maragall · Vilanova del Camí (Barcelona)",
  },
  {
    id: "llibertat",
    name: "Institut Escola Llibertat",
    latitude: 41.45481116369226,
    longitude: 2.232731697389753,
    description: "IES Llibertat · Badalona (Barcelona)",
  }
];
